import React from "react";
import service1 from "../../assets/images/assets/Frameworks/Frame 221.png"
import service2 from "../../assets/images/assets/Frameworks/Frame 23.png"
import service3 from "../../assets/images/assets/Frameworks/Frame 24.png"
import service4 from "../../assets/images/assets/Frameworks/Frame 25.png"
import service5 from "../../assets/images/assets/Frameworks/Frame 26.png"
import service6 from "../../assets/images/assets/Frameworks/Frame 27.png"
import service7 from "../../assets/images/assets/Frameworks/Frame 28.png"
import service8 from "../../assets/images/assets/Frameworks/Frame 29.png"

const FancyFeatureTewentyFour = () => {
  return (
    <div className="row">
      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#3FE193" }}
            >
              <img style={{ width: "65%" }} src={service1} alt="icon" />
            </div>
            <div className="text">
              <h4>Unique Marketing Opportunities
              </h4>
              <p>
                Achieve unparalleled outreach through innovative and effective campaigns.
              </p>
            </div>
          </div>
        </div>
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FF4F86" }}
            >
              <img style={{ width: "65%" }} src={service2} alt="icon" />
            </div>
            <div className="text">
              <h4>Upgraded Brand Awareness</h4>
              <p>
                Boost your brand's visibility in target markets with our strong and enduring presence.

              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FFCF39" }}
            >
              <img style={{ width: "65%" }} src={service3} alt="icon" />
            </div>
            <div className="text">
              <h4>Customized Marketing
              </h4>
              <p>
                Using relevant customer experiences and customized messaging to offer a distinctive and pertinent solution.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#6D64FF" }}
            >
              <img style={{ width: "65%" }} src={service4} alt="icon" />
            </div>
            <div className="text">
              <h4>Increased sales
              </h4>
              <p>
                Interactive shopping experiences and captivating product visualizations in the user's space increase conversions
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#E752FF" }}
            >
              <img style={{ width: "65%" }} src={service5} alt="icon" />
            </div>
            <div className="text">
              <h4>Competitive Advantage
              </h4>
              <p>
                Make your products stand out from the competition with innovative AR that appeals to your target market and offers distinctive value.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#29EEFB" }}
            >
              <img style={{ width: "65%" }} src={service6} alt="icon" />
            </div>
            <div className="text">
              <h4>Enhanced customer service
              </h4>
              <p>Enhance customer loyalty with exceptional support and personalized engagement.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#32B5FF" }}
            >
              <img style={{ width: "65%" }} src={service7} alt="icon" />
            </div>
            <div className="text">
              <h4>Cross-platform compatibility
              </h4>
              <p>
                Ensure seamless user experiences with universal accessibility, guaranteeing consistent functionality and optimal performance on devices and operating systems.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}

      <div
        className="col-lg-6 d-flex mb-35"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <div className="block-style-twentyFour">
          <div className="d-flex align-items-start">
            <div
              className="icon d-flex align-items-center justify-content-center"
              style={{ background: "#FFA361" }}
            >
              <img style={{ width: "65%" }} src={service8} alt="icon" />
            </div>
            <div className="text">
              <h4>Communication and Collaboration
              </h4>
              <p>
                Our integrated platforms and tools facilitate transparent information flow, streamline teamwork, and enhance engagement for unified objectives.
              </p>
            </div>
          </div>
        </div>{" "}
        {/* /.block-style-twentyFour */}
      </div>
      {/* End .col */}
    </div>
  );
};

export default FancyFeatureTewentyFour;
